export const VENUE_TYPES = {
  CANNABIS_CLUB: "cannabis_club",
  CBD_SHOP: "cbd_shop",
  SOCIAL_CLUB: "social_club",
  BISTRO: "bistro",
};

export const DEFAULT_VENUE_TYPE = VENUE_TYPES.CANNABIS_CLUB;

export const VENUE_TYPE_OPTIONS = [
  { value: VENUE_TYPES.CANNABIS_CLUB, label: "Cannabis Club" },
  { value: VENUE_TYPES.CBD_SHOP, label: "CBD Shop" },
  { value: VENUE_TYPES.SOCIAL_CLUB, label: "Social Club" },
  { value: VENUE_TYPES.BISTRO, label: "Bistro" },
];

export const VENUE_TYPE_CONFIG = {
  [VENUE_TYPES.CANNABIS_CLUB]: {
    brandName: "clubsagent.ai",
    appBackgroundClassName: "bg-gray-50",
    surfaceTintClassName: "bg-white border-b border-gray-200",
    memberLabel: "Socios",
    productLabel: "Productos",
    productEntityLabel: "producto",
    showEntries: true,
    showMembers: true,
    showProducts: true,
    showCarts: true,
    showCalendar: true,
    showDispenser: true,
  },
  [VENUE_TYPES.CBD_SHOP]: {
    brandName: "clubsagent.ai CBD",
    appBackgroundClassName: "bg-[radial-gradient(circle_at_top,_#efe8d7_0%,_#e8f0e4_46%,_#f7f6f1_100%)]",
    surfaceTintClassName: "bg-[#f3efe4]",
    memberLabel: "Clientes",
    productLabel: "Productos",
    productEntityLabel: "producto",
    showEntries: false,
    showMembers: false,
    showProducts: true,
    showCarts: true,
    showCalendar: true,
    showDispenser: true,
  },
  [VENUE_TYPES.SOCIAL_CLUB]: {
    brandName: "clubsagent.ai Social",
    appBackgroundClassName: "bg-[radial-gradient(circle_at_top,_#efe7dc_0%,_#e6edf2_44%,_#f7f6f2_100%)]",
    surfaceTintClassName: "bg-[#f1eee8]",
    memberLabel: "Socios",
    productLabel: "Productos",
    productEntityLabel: "producto",
    showEntries: true,
    showMembers: true,
    showProducts: true,
    showCarts: true,
    showCalendar: true,
    showDispenser: false,
  },
  [VENUE_TYPES.BISTRO]: {
    brandName: "bistroagent.ai",
    appBackgroundClassName: "bg-[radial-gradient(circle_at_top,_#fff1e6_0%,_#f8f0e8_40%,_#faf7f3_100%)]",
    surfaceTintClassName: "bg-[#fbf2e8]",
    memberLabel: "Clientes",
    productLabel: "Carta",
    productEntityLabel: "item",
    showEntries: false,
    showMembers: false,
    showProducts: true,
    showCarts: true,
    showCalendar: true,
    showDispenser: false,
  },
};

export function getVenueTypeConfig(venueType) {
  return VENUE_TYPE_CONFIG[venueType] || VENUE_TYPE_CONFIG[DEFAULT_VENUE_TYPE];
}

export function getVenueBrandName(venueType) {
  return getVenueTypeConfig(venueType).brandName;
}
